import { useNavigate } from 'react-router-dom'
import { Paper, Text, Group, Badge, Stack, Box } from '@mantine/core'
import { IconBook, IconUsers } from '@tabler/icons-react'

export function StoryCard({ story }) {
  const navigate = useNavigate()

  return (
    <Paper
      p="lg"
      className="glass"
      style={{
        cursor: 'pointer',
        transition: 'all 0.2s ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = 'var(--bw-accent)'
        e.currentTarget.style.transform = 'translateY(-2px)'
        e.currentTarget.style.boxShadow = '0 4px 20px var(--bw-glow-color)'
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = 'var(--bw-panel-border)'
        e.currentTarget.style.transform = 'translateY(0)'
        e.currentTarget.style.boxShadow = 'none'
      }}
      onClick={() => navigate(`/stories/${story.id}`)}
    >
      <Stack gap="sm">
        <Text fw={600} size="lg" ff="var(--bw-heading-font)" style={{ color: 'var(--bw-accent)' }} lineClamp={2}>
          {story.name}
        </Text>

        {story.scenario_name && (
          <Text size="sm" c="dimmed" lineClamp={2}>
            {story.scenario_name}
          </Text>
        )}

        {story.description && (
          <Text size="sm" c="gray.5" lineClamp={3}>
            {story.description}
          </Text>
        )}

        <Group gap="xs" mt="xs">
          {story.threads_count > 0 && (
            <Badge
              size="sm"
              variant="light"
              color="cyan"
              leftSection={<IconBook size={12} />}
            >
              {story.threads_count} {story.threads_count === 1 ? 'chapter' : 'chapters'}
            </Badge>
          )}
          {story.characters_count > 0 && (
            <Badge
              size="sm"
              variant="light"
              color="teal"
              leftSection={<IconUsers size={12} />}
            >
              {story.characters_count}
            </Badge>
          )}
        </Group>
      </Stack>
    </Paper>
  )
}
